import { render, staticRenderFns } from "./ShareLinkDashboardModal.vue?vue&type=template&id=71cd9f15&"
import script from "./ShareLinkDashboardModal.vue?vue&type=script&lang=js&"
export * from "./ShareLinkDashboardModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports